// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__r36lR","header":"card_header__0nsBF","hero":"card_hero__fALTE","logo":"card_logo__nB41c","content":"card_content__kYIiy"};